import React from 'react'
import { Avatar } from '@mui/material';
import { DateTime } from 'luxon'
import { Check, Close } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import Text from '../genericComponents/Text';

const GridCell = ({ column, item }) => {

    const theme = useTheme();
    const getFlaggedEnum = (statusNum, values) => {
        const statusses = [];

        Object.keys(values).forEach((value) => {
            if ((statusNum & values[value]) === values[value])
                statusses.push(value);
        });
        return statusses;
    };

    const getEnum = (enumValue, values) => {
        const keys = Object.keys(values);
        for (let i = 0; i < keys.length; i++) {
            if (enumValue === values[keys[i]]) {
                return keys[i];
            }
        }
    };

    const intFormatter = (int, type) => {
        switch (type) {
            case 'size': {
                let sizeType = 'b'
                let sizeAmount = int
                const sizeChecker = num => {
                    if (num >= 1024) {
                        sizeAmount = sizeAmount / 1024
                        switch (sizeType) {
                            case 'b': sizeType = 'kb'; break
                            case 'kb': sizeType = 'mb'; break
                            case 'mb': sizeType = 'gb'; break
                            case 'gb': sizeType = 'tb'; break
                            default: sizeType = 'tb'; break
                        }
                        sizeChecker(sizeAmount)
                    } else {
                        return sizeAmount
                    }
                }
                sizeChecker(sizeAmount)
                return parseFloat(sizeAmount).toFixed(1).toString() + " " + sizeType
            }
            default: return int
        }
    }
    switch (column.dataType) {
        case "OBJECT[]":
        case "OBJECT":
            return <Text title={item[column.propertyName]} variant='body1' style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', paddingRight: theme.spacing() }}>{item["displayName"]}</Text>
        case "String[]":
        case "String":
            let value = item[column.propertyName];
            return <Text text={value} variant='body1' style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', paddingRight: theme.spacing() }} />
        case "avatar":
            return (
                <Avatar
                    alt={item.name}
                    src={item[column.propertyName]}
                    style={{ margin: `${theme.spacing()} 0` }}
                    sx={{ bgcolor: theme.palette.secondary.main }}
                >
                    {item.givenName[0] + item.familyName[0]}
                </Avatar>
            );
        case "int":
        case "float":
            return (
                <Text text={intFormatter(parseInt(item[column.propertyName]), column.propertyName)} variant="body1" />
            );
        case "DateTime":
            return (
                <Text text={DateTime.fromISO(`${item[column.propertyName]}`).toRelative()} variant="body1" />
            );
        case "Boolean":
            return (item[column.propertyName] ? <Check /> : <Close />);
        case "enum":
            return (
                <Text text={getEnum(item[column.propertyName], column.eumValues)} variant="body1" />
            );
        case "custom":
            return <p>TODO...</p>;
        case "flaggedenum":
            return (
                <Text text={getFlaggedEnum(item[column.name], column.enumValues).map(
                    (status, i) =>
                        `${status}${getFlaggedEnum(item[column.propertyName], column.enumValues)
                            .length !==
                            i + 1
                            ? ", "
                            : ""
                        }`
                )} variant="body1" />
            );
        case "enum-EntityType":
            return (
                <div className={`fi fi-${item.extension}`} style={{ margin: `${theme.spacing()} 0` }}>
                    <div className='fi-content'>{item.extension}</div>
                </div>
            )
        default:
            return (<Text text={item[column.propertyName]} variant="body1" />);
    }
}

export default GridCell
